import { dynamicLoadUpgradeQueries } from '../utils';
export const isCurrentProductQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    getCurrentProduct
  } = await dynamicLoadUpgradeQueries(httpClient);
  const {
    currentProduct
  } = await getCurrentProduct({});
  return {
    isCurrentProduct: (currentProduct == null ? void 0 : currentProduct.productId) === request.productId
  };
};
//# sourceMappingURL=isCurrentProduct.query.js.map